module.exports = __webpack_public_path__ + "components/country-flag/static/bb-a820f369509efe4efe9128b662ae0205.svg";